import React from 'react';
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap'
import { useEffect, useState } from 'react';
import useToken from '../../App/useToken';
import './Header.css';

export default function Header ({ forceLogout }) {
  const { getUser, getRole } = useToken();
  const [user, setUser] = useState();
  const [label, setLabel] = useState();
  const [profileRedirect, setProfileRedirect] = useState();
  const [navClass, setNavClass] = useState();
  const role = getRole();

  useEffect(() => {
    const rawUser = getUser();
    if (rawUser) {
      const user = JSON.parse(rawUser);
      setUser(user)
    }
  }, []);

  const getRoleLabel = (role) => {
    switch (role) {
      case 'admin':
        return 'ผู้ดูแลระบบ';
      case 'adminViewer':
        return 'ผู้ดูแลระบบ(ReadOnly)';
      case 'adminUnit':
        return 'นขต.ทอ.';
      case 'adminUnitSpc':
        return 'หน่วย หน.สาย';
      case 'student':
        return 'ผู้มีสิทธิเรียน';
    }
  }

  useEffect(() => {
    switch (role) {
      case 'student':
        setLabel(`${user?.rankAbbrName}${user?.fullName}|${user?.unit}|${getRoleLabel(role)}`);
        setProfileRedirect(`students/${user?._id}/edit`);
        setNavClass('student');
        break;
      case 'adminUnit':
        setLabel(`${user?.rankAbbrName}${user?.fullName}|${user?.unit}|${getRoleLabel(role)}`);
        setProfileRedirect(`units/${user?._id}`);
        setNavClass('admin-unit');
        break;
      case 'adminUnitSpc':
        setLabel(`${user?.rankAbbrName}${user?.fullName}|${user?.unitSpcName}|${getRoleLabel(role)}`);
        setProfileRedirect(`spcs/${user?._id}`);
        setNavClass('admin-unit-spc');
        break;
      case 'admin':
        setLabel(`${user?.rankAbbrName}${user?.fullName}|${user?.unit}|${getRoleLabel(role)}`);
        setProfileRedirect(`admin/${user?._id}`);
        setNavClass('admin');
        break;
      case 'adminViewer':
        setLabel(`${user?.rankAbbrName}${user?.fullName}|${user?.unit}|${getRoleLabel(role)}`);
        setProfileRedirect(`admin/${user?._id}`);
        setNavClass('admin');
        break;
      default:
        break;
    }
  }, [user]);

  function onLogout() {
    forceLogout();
  }

  const onProfileClick = () => {
    window.location.pathname = profileRedirect;
  }

  return (
    <Navbar collapseOnSelect expand="lg" className={navClass} variant="dark">
      <Container>
        <Navbar.Brand href="/majorcourses">กองการศึกษา({label})</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            {/* <Nav.Link href="#features">Course</Nav.Link> */}
          </Nav>
          <Nav>
            <NavDropdown title="อื่นๆ" id="collasible-nav-dropdown">
              <NavDropdown.Item onClick={onProfileClick}>โปรไฟล์</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={onLogout}>ออกจากระบบ</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
};

Header.propTypes = {};

Header.defaultProps = {};
